import type { ElementType, HTMLAttributes, ReactNode } from "react";
import "./Panel.scss";

type PanelProps = HTMLAttributes<HTMLElement> & {
  as?: ElementType;
  children?: ReactNode;
};

export function Panel({
  as: Component = "div",
  children,
  className = "",
  ...props
}: PanelProps) {
  return (
    <Component className={`panel ${className}`.trim()} {...props}>
      {children}
    </Component>
  );
}
